<template>
  <div id="home">
    <div class="floor">
      <div class="floor_1">
        <div class="floor_top">
          <p class="floor_onep" style="color:#fff;">使用今云AI拓客，为业务加速</p>
          <p>
            <el-button type="primary" class="shses" @click="helseshi = true">申请使用</el-button>
          </p>
        </div>
      </div>
      <div class="floor_2">
        <div class="floor_left">
          <p class="floor_img">
            <img src="../assets/home/bottom_logo.png" alt />
          </p>
          <div class="floor_left_1">
            <p>商汇（天津）信息技术有限公司</p>
            <p>联系电话：022-8821-9596</p>
          </div>
          <div class="floor_left_2">
            <p>
              <a
                href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action"
                target="_blank"
              >津ICP备19005305号-6</a>
            </p>
            <p>
              <img src="../assets/home/bottom_icon.png" alt />
            </p>
            <p>
              <a
                href="https://www.beian.gov.cn/portal/index.do"
                target="_blank"
              >公安网备案12010302001766号</a>
            </p>
          </div>
        </div>
        <div class="floor_right">
          <div class="floor_right_1">
            <p class="floor_right_p">产品介绍</p>
            <ul class="floor_right_ul1" @click="add()">
              <li>
                <a href="#1">提升品牌</a>
              </li>
              <li>
                <a href="#2">降低成本</a>
              </li>
              <li>
                <a href="#3">一键转发</a>
              </li>
              <li>
                <a href="#4">电子名片</a>
              </li>
              <li>
                <a href="#5">数据追踪</a>
              </li>
            </ul>
            <ul class="floor_right_ul2" @click="add()">
              <li>
                <a href="#6">智能报表</a>
              </li>
              <li>
                <a href="#7">智能管理</a>
              </li>
              <li>
                <a href="#8">员工管理</a>
              </li>
              <li>
                <a href="#9">智能AI拓客</a>
              </li>
            </ul>
          </div>
          <div class="floor_right_1">
            <p class="floor_right_p1">解决方案</p>
            <ul class="floor_right_ul1">
              <li><a href="#10" @click="solve()">服务内容</a></li>
              <li><a href="#11" @click="solve()">服务价格</a></li>
              <li><a href="#12" @click="solve()">服务流程</a></li>
              <li @click="helsoe = true">渠道合作</li>
            </ul>
          </div>
          <div class="floor_right_1">
            <p class="floor_right_p2">关于我们</p>
            <ul class="floor_right_ul1">
              <li @click.stop="addqi()"><a>企业介绍</a></li>
              <li @click.stop="addqi1()"><a>奖项荣誉</a></li>
              <li @click.stop="addqi2()"><a>新闻资讯</a></li>
              <li @click.stop="addqi3()"><a>联系我们</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="float tsheng">
      <div class="dingbu_img">
        <img
          src="../assets/huaguo/hover_btn_xcx.png"
          alt
          class="dingbu_img_1"
          v-show="seen&&index==current"
        />
        <img
          src="../assets/huaguo/hover_btn_wx.png"
          alt
          class="dingbu_img_2"
          v-show="seen1&&index==current1"
        />
        <img
          src="../assets/huaguo/hover_btn_wx(1).png"
          alt
          class="dingbu_img_3"
          v-show="seen2&&index==current2"
        />
      </div>
      <div class="float_s ">
        <div class="float_top">
          <ul>
            <li @mouseenter="imgs(index)" @mouseleave="img()">小程序</li>
            <li @mouseenter="imgs1(index)" @mouseleave="img1()">客服微信</li>
            <li @click="helsoe = true">渠道合作</li>
            <li @mouseenter="imgs2(index)" @mouseleave="img2()">电话咨询</li>
          </ul>
        </div>
        <div class="float_right">
          <img src="../assets/huaguo/hover_btn_top_nor.png" alt class="float_img" />
          <img src="../assets/huaguo/hover_btn_top_sel.png" alt class="float_img1" @click="backtop" />
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="helseshi" width="584px">
      <div class="hesll" style="margin-bottom:20px;" >
        <p>现在注册，免费体验</p>
        <p></p>
      </div>
      <el-form
        :inline="true"
        :model="formregister"
        :rules="rulesregister"
        ref="formregister"
        class="demo-form-inlineds"
        style="margin-left:100px;margin-right: 100px"
        label-width="120px"
        hide-required-asterisk
        close-on-press-escape="false"
        close-on-click-modal="false"
      >
        <div class="input">
          <el-form-item label="登录账号" style="margin-left:10px" class="wh" prop="account">

            <el-input class="minaword" type="text" placeholder="请输入账号（同时作为小程序名称）" autocomplete="off" v-model="formregister.account" />

          </el-form-item>

        </div>
        <div class="new_wied"> 登录账号=小程序名称</div>
        <div class="input">
          <el-form-item label="密码" style="margin-left:10px " class="wh" prop="password" >
            <el-input class="minaword" show-password placeholder="请输入登录密码" v-model="formregister.password"></el-input>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="确认密码" style="margin-left:10px " class="wh" prop="agenpassword">
            <el-input class="minaword" show-password placeholder="请再次输入登录密码" v-model="formregister.agenpassword"></el-input>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="手机号" style="margin-left:10px" class="wh" prop="phone" >
            <el-input class="minaword" type="text" placeholder="请输入您的手机号" v-model="formregister.phone" autocomplete="off"/>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="推荐人手机号" style="margin-left:10px" class="wh" >
            <el-input class="minaword" type="text" placeholder="如有，则填写" v-model="formregister.agent_phone" autocomplete="off" />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button  v-if="fenyed ===1" type="primary" class="buttons" @click="registerd(formregister)">注册并登录</el-button>
          <div class="fle_butern">
            <div></div>
            <div>已有账号，<el-button class="fle-butt" @click="lodnin">直接登录</el-button></div>
          </div>
        </el-form-item>
      </el-form>
      <div class="floords">
        <p>如有疑问，可拨打咨询热线： 022-8821-9596</p>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="helsoe" width="900px">
      <div class="hesll" style="margin-bottom:20px;">
        <p>申请成为合作人</p>
        <p>请添加您的信息，我们将第一时间与您联系</p>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm"
      >
        <el-form
          :inline="true"
          :model="ruleForm"
          :rules="rules"
          class="demo-form-inline"
          label-width="200px"
        >
          <el-form-item label="姓名：" prop="name" style="margin-bottom:20px;">
            <el-input v-model="ruleForm.name" style="width:200px" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="申请区域：" prop="application_area">
            <el-cascader
              :options="options"
              :props="defaultParams"
              :change-on-select="true"
              :clearable="true"
              v-model="ruleForm.application_area"
              @change="handleChange"
              ref="cascaderAddr"
              style="width:200px;border-radius: 4px;
    border: 1px solid #DCDFE6;"
            ></el-cascader>
          </el-form-item>
        </el-form>
        <el-form-item label="手机号：" prop="phone" style="margin-bottom:20px;">
          <div class="phone">
            <input type="text" placeholder="请输入您的手机号" v-model="ruleForm.phone" />
            <!-- <p>|</p>
            <input type="text" placeholder="请输入验证码" class="inouts" />
            <button @click="getCode1()" class="code-btn" :disabled="!show">
              <span v-show="show">获取验证码</span>
              <span v-show="!show" class="count">重新发送({{count}})</span>
            </button>-->
          </div>
        </el-form-item>
        <el-form-item label="公司名称：" prop="company_name">
          <el-input v-model="ruleForm.company_name" style="width:80%" placeholder="请选输入公司名称"></el-input>
        </el-form-item>"
        <el-form-item label="所在地区：" style="margin-bottom:20px;">
          <el-input v-model="ruleForm.location" style="width:80%" placeholder="请选输入公司所在地区"></el-input>
        </el-form-item>
        <el-form-item label="公司概况：" style="margin-bottom:20px;">
          <el-input v-model="ruleForm.company_survey" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" class="bitton">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')" class="bitton1">取消</el-button>
        </el-form-item>
      </el-form>
      <div class="floors">
        <p>如有疑问，可拨打咨询热线： 022-8821-9596</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getintention_customer_add_sub } from "@/config/api";
import { getintention_agen_add_sub } from "@/config/api";
import {index_freeTrial } from "@/csconfig/api";
export default {
  name: "app-footer",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formregister.agenpassword !== '') {
          this.$refs.formregister.validateField('agenpassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formregister.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var valiphone = (rule, value, callback) =>{
      if (value === '') {
        callback(new Error('手机号不为空'));
      } else if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error("手机号格式错误"))
      }else{
        callback();
      }
    };
    var valiagentphone = (rule, value, callback) =>{
      if (value === '') {
        callback();
      } else if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error("手机号格式错误"))
      }else{
        callback();
      }
    };
    return {
      show2: false,
      show1: false,
      helsoe: false,
      wx: true,
      dy: false,
      tt: false,
      seen: 0,
      current: 0,
      seen1: 0,
      current1: 0,
      seen2: 0,
      current2: 0,
      seen3: 0,
      index: 0,
      helseshi: false,
      formInline: {
        name: "",
        phone: "",
        application_area: ""
      },
      options: [],
      count: "",
      show: true,
      TIME_COUNT: 60, //验证码倒计时60s
      defaultParams: {
        label: "name",
        value: "name",
        children: "children"
      },
      ruleForm: {
        name: "",
        phone: "",
        application_area: "",
        company_survey: "",
        company_name: "",
        location: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        application_area: [
          { required: true, message: "请选择申请区域", trigger: "change" }
        ]
      },
      formregister: {
        phone: "",
        password:'',
        agenpassword:'',
        account:'',
        agent_phone:'',
      },
      rulesregister: {
        phone: [{ validator: valiphone, trigger: 'blur' },],
        password: [ { validator: validatePass, trigger: 'blur' },],
        agenpassword: [{ validator: validatePass2, trigger: 'blur' },],
        account: [{ required: true,message: '请输入公司名称', trigger: 'blur' },],
        agent_phone:[{ validator: valiagentphone, trigger: 'blur' }]
      },
      zhucdengl:false,
      wangj:true,
      fenyed:1,
      urld:'https://card.sqifu.com/#/login'
    };
  },
  methods: {
    lever() {
      this.show = true;
      this.wx = true;
      this.show1 = false;
      this.tt = false;
      this.show2 = false;
      this.dy = false;
    },
    lever1() {
      this.show1 = true;
      this.dy = true;
      this.show = false;
      this.wx = false;
      this.show2 = false;
      this.tt = false;
    },
    lever2() {
      this.show2 = true;
      this.tt = true;
      this.show = false;
      this.wx = false;
      this.show1 = false;
      this.dy = false;
    },
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 50);
    },
    imgs() {
      this.seen = true;
      this.current = false;
    },
    img() {
      this.seen = true;
      this.current = null;
    },
    imgs1() {
      this.seen1 = true;
      this.current1 = false;
    },
    img1() {
      this.seen1 = true;
      this.current1 = null;
    },
    imgs2() {
      this.seen2 = true;
      this.current2 = false;
    },
    img2() {
      this.seen2 = true;
      this.current2 = null;
    },
    produ() {
      this.$router.push({
        path: "/product"
      });
    },
    addsup() {
      this.formInline.application_area = this.formInline.application_area.toString();
      getintention_customer_add_sub(this.formInline).then(res => {
        if (res.data.code == "20000") {
          this.$message({
            message: "申请成功",
            type: "success"
          });
          this.helseshi = false;
        }
      });
    },
    handleChange(value) {
      let labels = this.$refs["cascaderAddr"].currentLables;
    },
    //注册并登录
    getCode1() {
      if (!this.timer) {
        this.count = this.TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= this.TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //优质服务商
    getManagement() {
      this.$http(
        "https://www.newcoc.cn/WebProgram/WebApi/getRegionList",
        "post"
      ).then(res => {
        this.options = res.data.data;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.application_area = this.ruleForm.application_area.toString();
          getintention_agen_add_sub(this.ruleForm).then(res => {
            if (res.code == 20000) {
              this.$message({
                message: "申请成功",
                type: "success"
              });
              this.helsoe = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm.name = "";
      this.ruleForm.application_area = "";
      this.ruleForm.company_survey = "";
      this.ruleForm.location = "";
      this.helsoe = false;
    },
    add() {
      var num = 1;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/product"
      });
      this.$router.go(0);
    },
    solve(){
      var num = 2;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/solve"
      });
      this.$router.go(0);
    },
    addqi() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 0
        }
      });
      this.$router.go(0);
    },
    addqi1() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 1
        }
      });
      this.$router.go(0);
    },
    addqi2() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 2
        }
      });
      this.$router.go(0);
    },
    addqi3() {
      var num = 4;
      sessionStorage.setItem("num", num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 3
        }
      });
      this.$router.go(0);
    },
    //注册并登录   formregister
    registerd (formregister) {
      var that = this
      var formregister = that.formregister
      var urld = this.urld
      this.$refs.formregister.validate((valid) => {
        if (valid) {
          index_freeTrial(formregister).then(res =>{
            if (res.data.code == 200) {
              this.$message({
                message: "申请成功",
                type: "success"
              });
              this.helseshi = false;
              urld = urld + '?account=' + formregister.account + '&password=' + formregister.password
              window.location.href = urld
            }
            if(res.data.code ===400){
              this.$message({
                message: res.data.error,
                type: 'error'
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    lodnin () {
      this.zhucdengl = false
      this.wangj = true
      this.fenyed = 1
      window.location.href = this.urld
    }
  },
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },
  created() {
    this.getManagement();
  }
};
</script>

<style scoped>
@import "style.css";
@import "style1.css";
.cs{
  width: 500px;
  height: 500px;
  background: #333333;
  display: flex;
  position: fixed;
  top: 500px;
  right: 500px;
  z-index: 999;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.floor_onep {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 60px 0 40px 0;
}

.floor {
  width: 100%;
  height: 553px;
  background: #0a1633;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 54px;
}

.floor_top {
  width: 100%;
  height: 207px;
  border-bottom: 1px solid #263758;
}

.floor_top p:nth-child(2) {
  text-align: center;
}

.shses {
  width: 140px;
  height: 44px;
}

.floor_left {
  width: 600px;
  color: #9ba5b4;
  font-size: 14px;
  float: left;
}

.floor_2 {
  width: 1200px;
  margin: 0 auto;
}

.floor_img {
  margin-bottom: 30px;
}

.floor_left_1 {
  line-height: 30px;
  margin-bottom: 30px;
}

.floor_left_2 p {
  float: left;
  line-height: 22px;
}

.floor_left_2 p:nth-child(3) a,
.floor_left_2 p:nth-child(1) a {
  color: #9ba5b4;
  text-decoration: none;
}

.floor_left_2 p img {
  margin: 0 5px;
}

.floor_right {
  width: 600px;
  float: right;
  color: #9ba5b4;
}

.floor_right_1 {
  float: left;
  margin-right: 80px;
}

.floor_right_1:nth-child(3) {
  margin-right: 0;
}

.floor_right_p {
  width: 189px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p1 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p2 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_ul1 {
  font-size: 12px;
  float: left;
  margin-right: 39px;
}

.floor_right_ul1 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul1 li a {
  margin-bottom: 10px;
  cursor: pointer;
  color: #9ba5b4;
  text-decoration: none;
}

.floor_right_ul2 {
  font-size: 12px;
}

.floor_right_ul2 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 li a {
  margin-bottom: 10px;
  cursor: pointer;
  color: #9ba5b4;
  text-decoration: none;
}

.floor_right_ul2 li a:hover {
  color: #fff;
}

.floor_right_ul1 li a:hover {
  color: #fff;
}

.float {
  width: 240px;
  height: 300px;
  position: fixed;
  right: 0;
  bottom: 100px;
}

.float_top {
  width: 60px;
  height: 231px;
  background: rgba(23, 106, 253, 1);
  box-shadow: 0px 0px 8px 0px rgba(223, 227, 230, 0.6);
  border-radius: 4px 0px 0px 4px;
  overflow: hidden;
}

.float_top ul {
  width: 34px;
  height: 200px;
  margin: 0 auto;
  text-align: center;
  margin-top: 10px;
}

.float_top li {
  width: 34px;
  height: 46px;
  border-bottom: 1px solid #0044bc;
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 10px;
  cursor: pointer;
}

.float_top li:nth-child(4) {
  border: 0;
}

.float_right {
  width: 60px;
  height: 60px;
  background: rgba(225, 231, 240, 1);
  border-radius: 4px 0px 0px 4px;
  margin-top: 16px;
}

.float_img1 {
  display: none;
}

.float_right:hover .float_img1 {
  display: block;
}

.float_right:hover .float_img {
  display: none;
}

.dingbu_img {
  position: relative;
}

.dingbu_img_1 {
  width: 189px;
  height: 200px;
  position: absolute;
  top: -70px;
}

.dingbu_img_2 {
  position: absolute;
  top: -10px;
}

.dingbu_img_3 {
  position: absolute;
  top: 140px;
}

.float_s {
  float: right;
}

.hesll {
  text-align: center;
}

.hesll p:first-child {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 12px;
}

.hesll p:last-child {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.input {
  width: 384px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  margin-bottom: 20px;
}

.input input {
  border: 0;
  outline: 0;
}

.buttons {
  width: 384px;
  height: 40px;
}

.floors {
  width: 100%;
  height: 54px;
  background: rgba(241, 244, 248, 1);
  border-radius: 0px 0px 10px 10px;
  margin-top: 30px;
}

.floors p {
  text-align: center;
  line-height: 54px;
  color: #98abc1;
}

.hesll {
  text-align: center;
}

.hesll p:first-child {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 12px;
}

.hesll p:last-child {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.phone {
  width: 80%;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  display: flex;
  position: relative;
}

.phone input {
  border: 0;
  outline: 0;
  padding: 0 10px;
}

.phone p {
  color: #d7d7db;
}

.inouts {
  margin: 0 30px;
}

.code-btn {
  width: 115px;
  height: 40px;
  position: absolute;
  right: 0;
  z-index: 222;
  color: #fff;
  font-size: 14px;
  border: none;
  background-color: #337eff;
  cursor: pointer;
  outline: none;
  border-radius: 0px 4px 4px 0px;
}

.bitton {
  width: 202px;
  height: 44px;
  background: rgba(51, 126, 255, 1);
  border-radius: 4px;
}

.bitton1 {
  width: 134px;
  height: 44px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 223, 230, 1);
  border-radius: 4px;
}
.tsheng{
  z-index: 200;
}
/*新的注册页面*/
.floords {
  width: 100%;
  height: 54px;
  background: rgba(241, 244, 248, 1);
  border-radius: 0px 0px 10px 10px;
  margin-top: 30px;
}

.floords p {
  text-align: center;
  line-height: 54px;
  color: #98abc1;
}
.input {
  width: 384px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  margin-bottom: 20px;
}

.input input {
  border: 0;
  outline: 0;
}
.minaword >>>.el-input__inner{
  width: 240px;
  border: 0;
}
.linginput .minaword>>>.el-input__inner{
  width: 131px;
}
.linginput .minaword>>>.el-input-group__append{
  width: 39px;
}
.wh{
  width: 100%;
}
.minaword>>>.el-input__suffix{
  display: block !important;
}
.new_wied{
  background: #FFE5DB;
  color: #FF5614;
  padding: 3px 20px;
  border-radius: 10px;
  width: auto;
  display: inline-block;
  margin-bottom: 10px;
}
.fle-butt{
  border: none;
  color: #337EFF;
}
.demo-form-inlineds>>>.el-form-item__label{
  padding-left: 10px;
  color: #333333;
  text-align: left;
}
.fle_butern{
  display: flex;
  justify-content:space-between
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue